{
  "checkedInTitle": "คุณเช็กอินเรียบร้อยแล้ว",
  "postCheckInInstructions": "คำแนะนำหลังการเช็กอิน",
  "appointmentDetails": "รายละเอียดการนัดหมาย",
  "notifyWarehouse": "เราได้แจ้งคลังสินค้าแล้วว่าคุณมาถึง เพื่อให้คลังสินค้าตรวจสอบความพร้อม",
  "waitForStaff": "โปรดรอคำแนะนำเพิ่มเติมจากเจ้าหน้าที่คลังสินค้า",
  "unplannedDescription": "ดูเหมือนว่าคุณไม่มีการนัดหมาย โปรดรอคำแนะนำเพิ่มเติมจากเจ้าหน้าที่คลังสินค้า",
  "whatsappDelay": "ข้อความ WhatsApp ข้อความแรกอาจใช้เวลาถึงหนึ่งนาทีกว่าจะมาถึง",
  "bookNextTitle": "นัดหมายสำหรับครั้งถัดไป",
  "bookNextBody": "ลงทะเบียนกับ Opendock เพื่อให้คุณสามารถนัดหมายได้ในครั้งถัดไปที่มายังสถานที่นี้",
  "helpFooter": "หากคุณต้องการความช่วยเหลือหรือข้อมูลเพิ่มเติม โปรดติดต่อเจ้าหน้าที่คลังสินค้า",
  "finalize": "เสร็จสิ้น ({seconds})"
}
